import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {PageableApiResult} from "../models/pagable-api-result.model";
import {and, comparison, eq, ge, le} from "rsql-builder";
import {Oferta, OfertaListFilter} from "../models/oferta.model";
import {Transaccion} from "../models/transaccion.model";
import {delay} from "rxjs/operators";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class OfertaApiService {


  constructor(
    private httpClient: HttpClient
  ) { }

  searchOfertaRecibidaList(filter: OfertaListFilter): Observable<PageableApiResult<Oferta>> {
    const comps = [];

    if(filter.dateFilter && filter.dateFilter.from) {
      comps.push(comparison("date", ge(filter.dateFilter.from)))
    }
    if(filter.dateFilter && filter.dateFilter.to) {
      comps.push(comparison("date", le(filter.dateFilter.to)))
    }
    if(filter.numero) {
      comps.push(comparison("cheque.number", eq(filter.numero)))
    }
    if(filter.status) {
      comps.push(comparison("status.id", eq(filter.status)))
    }
    let params = null;
    if (comps.length > 0) {
      let q = and(...comps).toString();
      params = new HttpParams().set("rquery", q);
    }

    return this.httpClient.get<PageableApiResult<Oferta>>(
      environment.apiBaseUrl +
      `/core/portal/cheques/ofertas_recibidas/${filter.page}/${filter.size}`,
      {params}
    );
    // let x:PageableApiResult<Oferta> = JSON.parse('{\n' +
    //   '  "totalElements": 1,\n' +
    //   '  "totalPages": 1,\n' +
    //   '  "sort": {\n' +
    //   '    "sorted": true,\n' +
    //   '    "unsorted": true,\n' +
    //   '    "empty": true\n' +
    //   '  },\n' +
    //   '  "numberOfElements": 1,\n' +
    //   '  "first": true,\n' +
    //   '  "last": true,\n' +
    //   '  "pageable": {\n' +
    //   '    "sort": {\n' +
    //   '      "sorted": true,\n' +
    //   '      "unsorted": true,\n' +
    //   '      "empty": true\n' +
    //   '    },\n' +
    //   '    "unpaged": true,\n' +
    //   '    "paged": true,\n' +
    //   '    "pageNumber": 0,\n' +
    //   '    "pageSize": 0,\n' +
    //   '    "offset": 0\n' +
    //   '  },\n' +
    //   '  "size": 0,\n' +
    //   '  "content": [\n' +
    //   '    {\n' +
    //   '      "deletedDate": "2022-11-24T19:37:09.535Z",\n' +
    //   '      "id": 0,\n' +
    //   '      "cheque": {\n' +
    //   '        "deletedDate": "2022-11-24T19:37:09.535Z",\n' +
    //   '        "id": 0,\n' +
    //   '        "chequeTipo": {\n' +
    //   '          "id": "string",\n' +
    //   '          "description": "string"\n' +
    //   '        },\n' +
    //   '        "bank": {\n' +
    //   '          "deletedDate": "2022-11-24T19:37:09.535Z",\n' +
    //   '          "id": 0,\n' +
    //   '          "description": "string",\n' +
    //   '          "countryCode": "string"\n' +
    //   '        },\n' +
    //   '        "number": 0,\n' +
    //   '        "date": "2022-11-24T19:37:09.535Z",\n' +
    //   '        "dueDate": "2022-11-24T19:37:09.535Z",\n' +
    //   '        "importe": 0,\n' +
    //   '        "importeEsperado": 0,\n' +
    //   '        "librador": "string",\n' +
    //   '        "libradorIdNumber": "string",\n' +
    //   '        "libradorScore": {\n' +
    //   '          "id": "string",\n' +
    //   '          "description": "string"\n' +
    //   '        },\n' +
    //   '        "beneficiario": "string",\n' +
    //   '        "beneficiarioIdNumber": "string",\n' +
    //   '        "chequeStatus": {\n' +
    //   '          "id": "string",\n' +
    //   '          "description": "string",\n' +
    //   '          "published": true,\n' +
    //   '          "finished": true,\n' +
    //   '          "canPublish": true\n' +
    //   '        },\n' +
    //   '        "endosanteActualId": 0,\n' +
    //   '        "finalizado": "2022-11-24T19:37:09.535Z",\n' +
    //   '        "retiro": true,\n' +
    //   '        "tasa": 0,\n' +
    //   '        "margen": 0,\n' +
    //   '        "deliveryDate": "2022-11-24T19:37:09.535Z",\n' +
    //   '        "deliveryUserId": 0,\n' +
    //   '        "tna": 0,\n' +
    //   '        "tnaComision": 0,\n' +
    //   '        "tnaPorcentaje": 0,\n' +
    //   '        "flat": 0,\n' +
    //   '        "ivaComision": 0,\n' +
    //   '        "ivaTna": 0,\n' +
    //   '        "oferta": true,\n' +
    //   '        "calculaIvaTna": true,\n' +
    //   '        "montoInversor": 0,\n' +
    //   '        "tnaiPorcentaje": 0\n' +
    //   '      },\n' +
    //   '      "date": "2022-11-24T19:37:09.535Z",\n' +
    //   '      "endosanteId": 0,\n' +
    //   '      "inversorUserID": 0,\n' +
    //   '      "oferta": 0,\n' +
    //   '      "status": {\n' +
    //   '        "id": "string",\n' +
    //   '        "description": "string",\n' +
    //   '        "finished": true\n' +
    //   '      },\n' +
    //   '      "dateAccepted": "2022-11-24T19:37:09.535Z"\n' +
    //   '    }\n' +
    //   '  ],\n' +
    //   '  "number": 1,\n' +
    //   '  "empty": false\n' +
    //   '}')
    //
    // return of(x)

  }

  searchOfertaRealizadaList(filter: OfertaListFilter): Observable<PageableApiResult<Oferta>> {
    const comps = [];
    if(filter.status) {
      comps.push(comparison("status.id", eq(filter.status)))
    }
    if(filter.dateFilter && filter.dateFilter.from) {
      comps.push(comparison("date", ge(filter.dateFilter.from)))
    }
    if(filter.dateFilter && filter.dateFilter.to) {
      comps.push(comparison("date", le(filter.dateFilter.to)))
    }
    if(filter.numero) {
      comps.push(comparison("cheque.number", eq(filter.numero)))
    }

    let params = null;
    if (comps.length > 0) {
      let q = and(...comps).toString();
      params = new HttpParams().set("rquery", q);
    }

    return this.httpClient.get<PageableApiResult<Oferta>>(
      environment.apiBaseUrl +
      `/core/portal/cheques/ofertas_enviadas/${filter.page}/${filter.size}`,
      {params}
    );

    // let x:PageableApiResult<Oferta> = JSON.parse('{\n' +
    //   '  "totalElements": 0,\n' +
    //   '  "totalPages": 0,\n' +
    //   '  "sort": {\n' +
    //   '    "sorted": true,\n' +
    //   '    "unsorted": true,\n' +
    //   '    "empty": true\n' +
    //   '  },\n' +
    //   '  "numberOfElements": 0,\n' +
    //   '  "first": true,\n' +
    //   '  "last": true,\n' +
    //   '  "pageable": {\n' +
    //   '    "sort": {\n' +
    //   '      "sorted": true,\n' +
    //   '      "unsorted": true,\n' +
    //   '      "empty": true\n' +
    //   '    },\n' +
    //   '    "unpaged": true,\n' +
    //   '    "paged": true,\n' +
    //   '    "pageNumber": 0,\n' +
    //   '    "pageSize": 0,\n' +
    //   '    "offset": 0\n' +
    //   '  },\n' +
    //   '  "size": 0,\n' +
    //   '  "content": [\n' +
    //   '    {\n' +
    //   '      "deletedDate": "2022-11-24T19:37:09.535Z",\n' +
    //   '      "id": 0,\n' +
    //   '      "cheque": {\n' +
    //   '        "deletedDate": "2022-11-24T19:37:09.535Z",\n' +
    //   '        "id": 0,\n' +
    //   '        "chequeTipo": {\n' +
    //   '          "id": "string",\n' +
    //   '          "description": "string"\n' +
    //   '        },\n' +
    //   '        "bank": {\n' +
    //   '          "deletedDate": "2022-11-24T19:37:09.535Z",\n' +
    //   '          "id": 0,\n' +
    //   '          "description": "string",\n' +
    //   '          "countryCode": "string"\n' +
    //   '        },\n' +
    //   '        "number": 0,\n' +
    //   '        "date": "2022-11-24T19:37:09.535Z",\n' +
    //   '        "dueDate": "2022-11-24T19:37:09.535Z",\n' +
    //   '        "importe": 0,\n' +
    //   '        "importeEsperado": 0,\n' +
    //   '        "librador": "string",\n' +
    //   '        "libradorIdNumber": "string",\n' +
    //   '        "libradorScore": {\n' +
    //   '          "id": "string",\n' +
    //   '          "description": "string"\n' +
    //   '        },\n' +
    //   '        "beneficiario": "string",\n' +
    //   '        "beneficiarioIdNumber": "string",\n' +
    //   '        "chequeStatus": {\n' +
    //   '          "id": "string",\n' +
    //   '          "description": "string",\n' +
    //   '          "published": true,\n' +
    //   '          "finished": true,\n' +
    //   '          "canPublish": true\n' +
    //   '        },\n' +
    //   '        "endosanteActualId": 0,\n' +
    //   '        "finalizado": "2022-11-24T19:37:09.535Z",\n' +
    //   '        "retiro": true,\n' +
    //   '        "tasa": 0,\n' +
    //   '        "margen": 0,\n' +
    //   '        "deliveryDate": "2022-11-24T19:37:09.535Z",\n' +
    //   '        "deliveryUserId": 0,\n' +
    //   '        "tna": 0,\n' +
    //   '        "tnaComision": 0,\n' +
    //   '        "tnaPorcentaje": 0,\n' +
    //   '        "flat": 0,\n' +
    //   '        "ivaComision": 0,\n' +
    //   '        "ivaTna": 0,\n' +
    //   '        "oferta": true,\n' +
    //   '        "calculaIvaTna": true,\n' +
    //   '        "montoInversor": 0,\n' +
    //   '        "tnaiPorcentaje": 0\n' +
    //   '      },\n' +
    //   '      "date": "2022-11-24T19:37:09.535Z",\n' +
    //   '      "endosanteId": 0,\n' +
    //   '      "inversorUserID": 0,\n' +
    //   '      "oferta": 0,\n' +
    //   '      "status": {\n' +
    //   '        "id": "string",\n' +
    //   '        "description": "string",\n' +
    //   '        "finished": true\n' +
    //   '      },\n' +
    //   '      "dateAccepted": "2022-11-24T19:37:09.535Z"\n' +
    //   '    }\n' +
    //   '  ],\n' +
    //   '  "number": 0,\n' +
    //   '  "empty": true\n' +
    //   '}')
    //
    // return of(x).pipe(delay(2000))

  }

  aceptarOferta(idOferta: number) {
    return this.httpClient.post<Transaccion>(
      environment.apiBaseUrl +`/exchange/oferta/confirm/`+idOferta,{},{observe: 'response'}
    );
  }

  declinarOferta(idOferta: number):Observable<any> {
    return this.httpClient.post<any>(
      environment.apiBaseUrl +`/exchange/oferta/decline/`+idOferta,{},{observe: 'response'}
    );
  }

  declinarOfertaEnviada(idOferta: number):Observable<any> {
    return this.httpClient.post<any>(
      environment.apiBaseUrl +`/core/portal/cheques/ofertas_enviadas/declinar/`+idOferta,{},{observe: 'response'}
    );
  }

  getOfertaById(idOferta: number) {
    return this.httpClient.get<any>(
      environment.apiBaseUrl +`/core/portal/cheques/ofertas_recibidas/`+idOferta,{}
    );
  }
}

